import { Component, Input, forwardRef, OnInit, OnChanges, SimpleChanges, Inject } from '@angular/core';

import { AbstractFormFieldComponent } from '../../FormField/abstract-form-field.component';
import { FilterService } from '../../../../Filter/services/abstract-filter.service';
import { FixedChartSourceDataService } from '../../../../Dashboard/services/fixed-chart-source-data.service';
import { FilterFieldModel } from '../../../models/filter-field.model';
import { Subscription } from 'rxjs';

@Component({
    selector: 'agpr-filter-field',
    templateUrl: './filter-field.component.html',
    styleUrls: ['./filter-field.component.scss'],
    providers: [
        {
            provide: AbstractFormFieldComponent,
            useExisting: forwardRef(() => FilterFieldComponent)
        },
        {
            provide: FilterService,
            useExisting: FixedChartSourceDataService
        }
    ],
    standalone: false
})
export class FilterFieldComponent extends AbstractFormFieldComponent implements OnInit {
    @Input() declare field: FilterFieldModel;
    private subscriptions: Subscription[] = [];
    public hasFilters: boolean = false;
    public hasFilterChips: boolean = false;

    constructor(
        @Inject(FilterService) public fixedChartSourceDataService: FixedChartSourceDataService,
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.fixedChartSourceDataService.getFilters().subscribe(
                (filters) => {
                    this.hasFilters = filters && filters.length > 0;
                    this.hasFilterChips = this.hasFilters && !!filters.find(f => f.chips.length > 0);
                }
            ),
        );
        this.fixedChartSourceDataService.initFilters(this.block);
    }
}
